import type { MailClockFormatId } from "@/mail/prefs";

/** List-row time shared by Mail and Chat: clock time for today, otherwise "Sep 25". */
export function formatListWhen(value?: string | number | null, clock: MailClockFormatId = "12h"): string {
  if (value == null || value === "") return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return typeof value === "string" ? value : "";
  const now = new Date();
  const sameDay =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();
  if (sameDay) {
    return date.toLocaleTimeString(undefined, {
      hour: "numeric",
      minute: "2-digit",
      hour12: clock !== "24h",
    });
  }
  return date.toLocaleString(undefined, { month: "short", day: "numeric" });
}
